<template>
  <div class="goods" id="goods" name="goods">
    <!-- 面包屑 -->
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>商家入驻</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑END -->

    <!-- 入驻表单卡片区 -->
    <div class="main">
      <div class="settlement-card">
        <h2 class="page-title">入驻申请</h2>
        
        <!-- 经营类目选择 -->
        <div class="form-section">
          <div class="section-title">经营类目 <span class="required">*</span></div>
          <div class="category-grid">
            <div 
              v-for="item in categoryList" 
              :key="item.id"
              class="category-item"
              :class="{ active: selectedCategory === item.id }"
              @click="selectedCategory = item.id"
            >
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <!-- 店铺类型 -->
        <div class="form-section">
          <div class="section-title">店铺类型 <span class="required">*</span></div>
          <div class="type-group">
            <el-radio-group v-model="storeType" size="medium">
              <el-radio-button 
                v-for="type in storeTypes" 
                :key="type.value" 
                :label="type.value"
              >
                {{ type.label }}
              </el-radio-button>
            </el-radio-group>
          </div>
        </div>

        <!-- 资质上传 -->
        <div class="form-section">
          <div class="section-title">
            请上传营业执照及行业相关资质证明图片 
            <span class="required">*</span>
            <span class="upload-tip">(图片最多可上传10张，单张图片不超过5M，图片格式支持JPG、PNG、JPEG)</span>
          </div>
          <el-upload
            class="upload-area"
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
            :file-list="fileList"
            list-type="picture-card"
            multiple
            :limit="10"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">最多上传10张，每张不超过5M</div>
          </el-upload>
        </div>

        <!-- 联系人姓名 -->
        <div class="form-section">
          <div class="section-title">联系人姓名 <span class="required">*</span></div>
          <el-input 
            v-model="contactName" 
            placeholder="请输入真实姓名"
            class="input-field"
            clearable
          ></el-input>
        </div>

        <!-- 联系电话 -->
        <div class="form-section">
          <div class="section-title">联系电话 <span class="required">*</span></div>
          <el-input 
            v-model="contactPhone" 
            placeholder="请输入手机号码"
            class="input-field"
            clearable
            type="tel"
            maxlength="11"
          ></el-input>
          <div v-if="phoneError" class="field-error">{{ phoneError }}</div>
        </div>

        <!-- 入驻协议 -->
        <div class="form-section protocol">
          <el-checkbox v-model="agreed">
            我已阅读并同意 <a href="/agreement" target="_blank">《入驻协议》</a>
          </el-checkbox>
        </div>

        <!-- 安全验证（简单滑块示例） -->
        <div class="form-section captcha">
          <div class="section-title">请完成安全验证 <span class="required">*</span></div>
          <div class="slider-captcha" :class="{ success: captchaPassed }">
            <div class="slider-track" ref="sliderTrack" @mousedown="startDrag">
              <div class="slider-button" :style="{ left: sliderLeft + 'px' }">
                <i v-if="!captchaPassed" class="el-icon-d-arrow-right"></i>
                <i v-else class="el-icon-check"></i>
              </div>
              <div class="slider-text" v-if="!captchaPassed">按住滑块，拖动到最右侧</div>
              <div class="slider-text success-text" v-else>验证通过</div>
            </div>
          </div>
        </div>

        <!-- 提交按钮 -->
        <div class="form-actions">
          <el-button type="primary" size="large" @click="submitSettlement" :disabled="!isFormValid">提交申请</el-button>
        </div>
      </div>
    </div>
    <!-- 主要内容区END -->
  </div>
</template>

<script>
export default {
  name: 'MerchantSettlement',
  data() {
    return {
      // 经营类目数据
      categoryList: [
        { id: 1, name: '工业化学品', icon: 'el-icon-medicine' },
        { id: 2, name: '建筑胶', icon: 'el-icon-house' },
        { id: 3, name: '民用化学品', icon: 'el-icon-magic-stick' },
      ],
      selectedCategory: null,      // 选中的类目id
      storeTypes: [               // 店铺类型选项
        { value: 'flagship', label: '旗舰店' },
        { value: 'specialty', label: '专营店' },
        { value: 'member', label: '会员店' },
        { value: 'franchise', label: '加盟店' },
        { value: 'factory', label: '工厂店' },
        { value: 'self', label: '自营' }
      ],
      storeType: '',              // 选中的店铺类型
      fileList: [],              // 上传文件列表
      contactName: '',           // 联系人姓名
      contactPhone: '',          // 联系电话
      agreed: false,             // 协议勾选
      captchaPassed: false,      // 验证是否通过
      sliderLeft: 0,            // 滑块位置（px）
      dragging: false,          // 是否正在拖拽
      startX: 0,                // 拖拽起始X
      maxLeft: 0                // 滑块最大可移动距离
    }
  },
  computed: {
    // 手机号错误信息
    phoneError() {
      if (!this.contactPhone) return ''
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phoneRegex.test(this.contactPhone)) {
        return '请输入有效的11位手机号码'
      }
      return ''
    },
    // 姓名是否有效
    isNameValid() {
      return this.contactName && this.contactName.trim().length > 0
    },
    // 电话是否有效
    isPhoneValid() {
      const phoneRegex = /^1[3-9]\d{9}$/
      return this.contactPhone && phoneRegex.test(this.contactPhone)
    },
    // 表单整体有效性
    isFormValid() {
      return this.selectedCategory && 
             this.storeType && 
             this.fileList.length > 0 && 
             this.isNameValid &&
             this.isPhoneValid &&
             this.agreed && 
             this.captchaPassed
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.calcMaxLeft()
      window.addEventListener('resize', this.calcMaxLeft)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcMaxLeft)
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
  },
  methods: {
    // 计算滑块最大可移动距离
    calcMaxLeft() {
      if (this.$refs.sliderTrack) {
        const trackWidth = this.$refs.sliderTrack.clientWidth
        const buttonWidth = 40
        this.maxLeft = trackWidth - buttonWidth
      }
    },
    // 开始拖拽验证
    startDrag(e) {
      if (this.captchaPassed) return
      this.dragging = true
      this.startX = e.clientX - this.sliderLeft
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },
    onDrag(e) {
      if (!this.dragging) return
      let newLeft = e.clientX - this.startX
      newLeft = Math.min(Math.max(0, newLeft), this.maxLeft)
      this.sliderLeft = newLeft
      if (newLeft >= this.maxLeft && !this.captchaPassed) {
        this.captchaPassed = true
        this.dragging = false
        document.removeEventListener('mousemove', this.onDrag)
        document.removeEventListener('mouseup', this.stopDrag)
      }
    },
    stopDrag() {
      if (!this.captchaPassed) {
        this.sliderLeft = 0
      }
      this.dragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
    // 文件变化处理
    handleFileChange(file, fileList) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$message.error('单张图片不能超过5M')
        const index = fileList.findIndex(f => f.uid === file.uid)
        if (index !== -1) fileList.splice(index, 1)
        return
      }
      const isValidType = ['image/jpeg', 'image/png', 'image/jpg'].includes(file.raw.type)
      if (!isValidType) {
        this.$message.error('图片格式仅支持 JPG、PNG、JPEG')
        const index = fileList.findIndex(f => f.uid === file.uid)
        if (index !== -1) fileList.splice(index, 1)
        return
      }
      this.fileList = fileList
    },
    handleFileRemove(file, fileList) {
      this.fileList = fileList
    },
    // 提交入驻申请
    submitSettlement() {
      if (!this.isFormValid) {
        let errorMsg = ''
        if (!this.selectedCategory) errorMsg = '请选择经营类目'
        else if (!this.storeType) errorMsg = '请选择店铺类型'
        else if (this.fileList.length === 0) errorMsg = '请上传资质证明图片'
        else if (!this.isNameValid) errorMsg = '请填写联系人姓名'
        else if (!this.isPhoneValid) errorMsg = '请填写有效的手机号码'
        else if (!this.agreed) errorMsg = '请阅读并同意入驻协议'
        else if (!this.captchaPassed) errorMsg = '请完成安全验证'
        else errorMsg = '请完整填写所有必填项并完成验证'
        
        this.$message.warning(errorMsg)
        return
      }
      
      const formData = new FormData()
      formData.append('category_id', this.selectedCategory)
      formData.append('store_type', this.storeType)
      formData.append('contact_name', this.contactName.trim())
      formData.append('contact_phone', this.contactPhone)
      formData.append('agreed', this.agreed)
      this.fileList.forEach(file => {
        formData.append('certificates[]', file.raw)
      })
      
      this.$message.info('正在提交入驻申请...')
      // 实际使用时替换为真实API调用
      // settlementAPI.apply(formData).then(...)
      setTimeout(() => {
        this.$message.success('入驻申请已提交，请等待审核')
        // 可跳转到其他页面
        // this.$router.push('/')
      }, 1000)
    }
  }
}
</script>

<style scoped>
/* 保持原有页面风格，复用大部分CSS，并添加入驻相关样式 */
.goods {
  background-color: #f2f2f2;
  min-height: 100vh;
}
/* 面包屑CSS */
.goods .breadcrumb {
  height: 50px;
  background-color: #f2f2f2;
}
.goods .breadcrumb .el-breadcrumb {
  width: 1225px;
  line-height: 50px;
  font-size: 16px;
  margin: 0 auto;
}
/* 主要内容区CSS */
.goods .main {
  margin: 0 auto;
  max-width: 1225px;
  padding: 20px 0 40px;
}
.settlement-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px 40px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
}
.page-title {
  font-size: 24px;
  font-weight: 500;
  color: #333;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e8e8e8;
}
.form-section {
  margin-bottom: 30px;
}
.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
}
.required {
  color: #f56c6c;
  margin-left: 4px;
}
.upload-tip {
  font-size: 12px;
  font-weight: normal;
  color: #999;
  margin-left: 10px;
}
/* 输入框样式 */
.input-field {
  max-width: 360px;
  width: 100%;
}
.field-error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  margin-top: 8px;
}
/* 经营类目网格 */
.category-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.category-item {
  width: 100px;
  padding: 12px 0;
  text-align: center;
  background: #f8f8f8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.category-item i {
  font-size: 28px;
  display: block;
  margin-bottom: 8px;
  color: #666;
}
.category-item span {
  font-size: 14px;
  color: #333;
}
.category-item:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
}
.category-item.active {
  background: #ecf5ff;
  border-color: #409eff;
}
.category-item.active i,
.category-item.active span {
  color: #409eff;
}
/* 店铺类型按钮组定制 */
.type-group .el-radio-button__inner {
  padding: 10px 20px;
  border-radius: 4px;
}
/* 上传组件样式调整 */
.upload-area {
  text-align: left;
}
.el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
/* 协议区 */
.protocol {
  margin-bottom: 25px;
}
.protocol .el-checkbox {
  font-size: 14px;
}
.protocol a {
  color: #409eff;
  text-decoration: none;
}
/* 滑块验证码样式 */
.slider-captcha {
  width: 360px;
  user-select: none;
}
.slider-track {
  position: relative;
  height: 40px;
  background-color: #e9e9e9;
  border-radius: 40px;
  cursor: pointer;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.1);
}
.slider-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: left 0.05s linear;
  z-index: 2;
}
.slider-button i {
  font-size: 20px;
  color: #409eff;
}
.slider-text {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  line-height: 40px;
  text-align: center;
  color: #999;
  font-size: 14px;
  pointer-events: none;
  z-index: 1;
}
.success-text {
  color: #67c23a;
}
.slider-captcha.success .slider-track {
  background-color: #e1f3d8;
}
.slider-captcha.success .slider-button {
  cursor: default;
  background-color: #67c23a;
}
.slider-captcha.success .slider-button i {
  color: #fff;
}
/* 提交按钮 */
.form-actions {
  text-align: center;
  margin-top: 40px;
}
.el-button--primary.is-disabled {
  background-color: #a0cfff;
  border-color: #a0cfff;
}
</style>